import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../../../../context/themeContext";
import truncateText from "../../../../../../../../../helpers/truncateText";

const Top = ({ data }) => {
  const { theme } = useTheme();

  return (
    <Box className={styles.top}>
      <Box className={styles.profile}>
        <Box
          className={styles.image}
          sx={{
            backgroundImage: `url(${data.profileImage})`,
            width: "32px",
            height: "32px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        ></Box>
        <Box className={styles.name}>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.darkgrey.darkgrey600,
            }}
          >
            {truncateText(data.realName, 5)}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.darkgrey.darkgrey300,
            }}
          >
            {data.nickName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Top;
